import './polyfills';
import './sentry';
import '@trinity/chat-components/websocket/debug'; // Initialize WebSocket debug utilities
import { createRoot } from 'react-dom/client';
import { App } from './app';

const container = document.getElementById('root');

const root = createRoot(container);

root.render(<App />);